export default __webpack_public_path__ + "static/media/studio-3.cb63e16b.jpg";